import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { CONTENT_SECTION_ACTION_TYPE } from "./content-section.action";
import { ContentSectionState } from "./content-section.model";

const initialState: ContentSectionState = {};

/**
 * @deprecated - [fabric-deprecated]
 */
export function contentSectionReducer(state = initialState, action: ActionWithPayload): ContentSectionState {
	switch (action.type) {
		case CONTENT_SECTION_ACTION_TYPE.getSuccess: {
			return updateState(state, action.payload);
		}
		default:
			return state;
	}
}
